// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const AUTH_AUTHENTICATING = "AUTH_AUTHENTICATING";
const AUTH_AUTHENTICATE_SUCCESS = "AUTH_AUTHENTICATE_SUCCESS";
const AUTH_INDEX_PERMISSIONS_SUCCESS = "AUTH_INDEX_PERMISSIONS_SUCCESS";
const AUTH_AUTHORITY_CHANGED = "AUTH_AUTHORITY_CHANGED";
const AUTH_CURRENT_USER_SUCCESS = "AUTH_CURRENT_USER_SUCCESS";
const AUTH_CURRENT_POSITION_SUCCESS = "AUTH_CURRENT_POSITION_SUCCESS";
const AUTH_CURRENT_ROLE_SUCCESS = "AUTH_CURRENT_ROLE_SUCCESS";
const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
const UI_PERMISSION_SUCCESS = "UI_PERMISSION_SUCCESS";
const SMS_PERMISSION_SUCCESS = "SMS_PERMISSION_SUCCESS"; // New constant for SMS panel permission
const FETCH_COMPANY_LOGO_SUCCESS = "FETCH_COMPANY_LOGO_SUCCESS"; // New constant for company logo

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _authenticateSuccess(payload) {
  return {
    type: AUTH_AUTHENTICATE_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexPermissionsSuccess(payload) {
  return {
    type: AUTH_INDEX_PERMISSIONS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showCurrentUserSuccess(payload) {
  return {
    type: AUTH_CURRENT_USER_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showCurrentPositionSuccess(payload) {
  return {
    type: AUTH_CURRENT_POSITION_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showCurrentRoleSuccess(payload) {
  return {
    type: AUTH_CURRENT_ROLE_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
export function uiPermission(payload) {
  return {
    type: UI_PERMISSION_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Boolean} hasSmsPermission
 * @return {{type: String, payload: Boolean}}
 */
export function smsPermission(hasSmsPermission) {
  return {
    type: SMS_PERMISSION_SUCCESS,
    payload: hasSmsPermission,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _fetchCompanyLogoSuccess(payload) {
  return {
    type: FETCH_COMPANY_LOGO_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 *
 * @param {Boolean} [authenticating=true]
 * @return {{type: String, payload: *, source: *}}
 */
export function authenticating(authenticating = true) {
  return {
    type: AUTH_AUTHENTICATING,
    payload: {
      authenticating,
    },
  };
}

/**
 *
 * @param {Boolean} [authenticated=true]
 * @return {{type: String, payload: *, source: *}}
 */
export function authenticated(authenticated = true) {
  return {
    type: AUTH_AUTHORITY_CHANGED,
    payload: {
      authenticated,
    },
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function authenticate(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    const loader = app.loading(app.translate("routes.auth.Logging in"));
    dispatch(authenticating());

    api
      .post("/login", { data })
      .then((res) => {
        if (res.companyAvailability !== 10) {
          dispatch(_authenticateSuccess(res));
          SmsPermissionFunction()(dispatch, gs, api);

          loader.hide(() =>
            app.message(app.translate("routes.auth.Logged in successfully"))
          );
        } else {
          loader.hide(() =>
            app.error(
              "",
              "routes.auth",
              "عدم ارتباط بادیتابیس",
              app.translate("routes.auth.Username or Password is incorrect")
            )
          );
        }

        // app.message(app.translate('routes.auth.Logged in successfully'));
        callback(undefined, res);
      })
      .catch((err) => {
        dispatch(authenticated(false));
        loader.hide(() =>
          app.error(
            err,
            "routes.auth",
            "لطفا از متصل بودن اینترنت خود اطمینان حاصل کنید.",
            app.translate("routes.auth.Username or Password is incorrect")
          )
        );
        // app.message(app.translate('routes.auth.Username or Password is incorrect'), 'error');
        callback(err);
      })
      .then(() => dispatch(authenticating(false)));
  };
}

/**
 *
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function SmsPermissionFunction(callback = () => {}) {
  return (dispatch, gs, api) => {
    try {
      // Check if user has SMS permission
      const hasSmsPermission = app.haveUiPermission(["afa244366dafa24366d32ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f1895932ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f18959"]);
      console.log("SMS Permission:", hasSmsPermission);
      // Update Redux state with the permission status immediately
      dispatch(smsPermission(hasSmsPermission));

      // Silently send the permission status to backend without affecting user flow
      api
        .put(`/Companies/EditDemo/${!hasSmsPermission}`)
        .then((res) => {
          // Already updated state above; backend call succeeded

          // Successfully sent to backend, no need for additional actions
          if (callback && typeof callback === "function") {
            callback(undefined, res);
          }
        })
        .catch((err) => {
          // Just log the error without showing error message to user
          console.error("Error sending SMS permission to backend:", err);

          // Still call the callback if provided
          if (callback && typeof callback === "function") {
            callback(err);
          }
        });
    } catch (error) {
      // Handle any exceptions in the permission checking process
      console.error("Error in SMS permission function:", error);

      // Set default permission as false in case of errors
      dispatch(smsPermission(false));

      if (callback && typeof callback === "function") {
        callback(error);
      }
    }
  };
}

/**
 *
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function logout(callback = () => {}) {
  return (dispatch, gs, api) => {
    const loader = app.loading(app.translate("routes.auth.Logging out"));

    api
      .post("/logout", { data: {} })
      .then((res) => {
        dispatch(authenticated(false));

        // Clear all cookies
        document.cookie.split(";").forEach((cookie) => {
          const name = cookie.split("=")[0].trim();
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
          // Also try with domain attribute for cross-domain cookies
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.hostname};`;
        });

        // Clear localStorage and sessionStorage
        localStorage.clear();
        sessionStorage.clear();

        // Clear application cache if supported
        if ("caches" in window) {
          caches.keys().then((keyList) => {
            return Promise.all(
              keyList.map((key) => {
                return caches.delete(key);
              })
            );
          });
        }

        // Clear IndexedDB if used
        indexedDB
          .databases()
          .then((dbs) => {
            dbs.forEach((db) => {
              indexedDB.deleteDatabase(db.name);
            });
          })
          .catch(() => {
            // Ignore errors
          });

        loader.hide(() =>
          app.message(app.translate("routes.auth.Logged out successfully"))
        );
        callback(undefined, res);
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "routes.auth",
            "خروج با شکست مواجه شد!",
            app.translate("routes.auth.Logging out failed")
          )
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function verifyAuthentication(callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/login/refresh", {
        data: { refreshToken: localStorage.getItem("refresh-token") },
      })
      .then((res) => {
        dispatch(_authenticateSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        console.log("salam iran error");

        window.location.reload();
        // app.message(app.translate("routes.auth.Token Expired"), "warning", 5);
        dispatch(authenticated(false));
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function emailResetToken(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/password/email", { data })
      .then((res) => {
        app.message(app.translate("routes.auth.Email Sent"));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.auth",
          "خطا در ارسال اطلاعات به ایمیل شما!",
          app.translate("routes.auth.Email Not Found")
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function resetPassword(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/password/reset", { data })
      .then((res) => {
        app.message(app.translate("routes.auth.Password changed successfully"));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function loginResetPassword(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/login/password/reset", { data })
      .then((res) => {
        app.message(app.translate("routes.auth.Password changed successfully"));
        callback(undefined, res);
        dispatch(authenticated(false));
      })
      .catch((err) => {
        app.message(
          app.translate("routes.auth.Password reset failed"),
          "error"
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexPermissions(callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/user/permissions")
      .then((res) => {
        if (!res.data.permissions || res.data.permissions.length === 0) {
          if (!app.isAdmin()) {
            app.message(
              app.translate("routes.auth.You don't have any permissions"),
              "warning"
            );
            dispatch(authenticated(false));
          }
        } else {
          dispatch(_indexPermissionsSuccess(res));
        }
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showCurrentUser(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    // وارد کردن تنظیمات API
    const apiConfig = require("../../config/api").default;
    // آدرس API با حذف پیشوند v1
    const baseUrlWithoutV1 = `${apiConfig.protocol}://${apiConfig.url.replace(
      "/v1",
      ""
    )}`;

    api
      .get("/user", { params })
      .then((res) => {
        // استفاده از آدرس پایه بدون پیشوند v1
        fetch(`${baseUrlWithoutV1}/api/Version`)
          .then((response) => response.json())
          .then((data) => {
            console.log("API Version info:", data);
            localStorage.setItem("Versions", JSON.stringify(data?.data));
          })
          .catch((error) => {
            console.error("Error fetching API version:", error);
          });

        dispatch(_showCurrentUserSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} positions
 * @return {{type: String, payload: Object}}
 */
export function changeCurrentPosition(positions = {}) {
  return _showCurrentPositionSuccess(positions);
}

/**
 *
 * @param {Object} data
 * @return {{type: String, payload: Object}}
 */
export function changeCurrentRole(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/user_active_role", { data })
      .then((res) => {
        dispatch(_showCurrentRoleSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

// ----------------------------------------------------------------< updateCompany >-------------------------------------------------------
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateCompanySuccess(payload) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Object} id
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateCompany(id, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .put(`/companies/${id}`, { data })
      .then((res) => {
        app.message(
          app.translate("routes.general.Company Update successfully")
        );
        dispatch(_updateCompanySuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.message(
          app.translate("routes.general.Company Update failed"),
          "error"
        );
        callback(err);
      });
  };
}

/**
 * Fetches the company logo from Companies/GetLogo endpoint
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function fetchCompanyLogo(callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/Companies/GetInfo")
      .then((res) => {
        dispatch(_fetchCompanyLogoSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        console.error("Error fetching company logo:", err);
        callback(err);
      });
  };
}

// ------------------------------------------------------------------< permissions >------------------------------------------------------------------

function _newPermissions(_permissions, currentPosition) {
  let permissions = [];

  if (_permissions && _permissions.user) {
    permissions =
      typeof _permissions.user === "object"
        ? Object.values(_permissions.user)
        : _permissions.user;

    if (currentPosition && currentPosition.id) {
      permissions.push(
        ...(currentPosition &&
        currentPosition.id &&
        _permissions.positions &&
        _permissions.positions[currentPosition.id]
          ? typeof _permissions.positions[currentPosition.id] === "object"
            ? Object.values(_permissions.positions[currentPosition.id])
            : _permissions.positions[currentPosition.id]
          : [])
      );
    }
    permissions.push(
      ...app._.uniq(permissions.map((permission) => permission.split("@")[0]))
    );
    permissions = app._.uniq(permissions);
  }

  return permissions;
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    authenticating: false,
    authenticated: localStorage.getItem("access-token") ? null : false,
    permissions: {},
    currentPermissions: [],
    uiPermissions: [],
    hasSmsPermission: false, // SMS panel permission
    currentUser: {},
    currentPosition: {},
    currentRole: 1,
    company: {},
    companyLogo: null, // New state for company logo
  },
  action
) {
  let permissions;
  let currentPosition;
  let currentRole;
  let currentPermissions;

  switch (action.type) {
    case AUTH_AUTHENTICATE_SUCCESS:
      localStorage.setItem("access-token", action.payload.accessToken);
      localStorage.setItem("refresh-token", action.payload.refreshToken);
      localStorage.setItem("isFirstLogin", action.payload.isFirstLogin);
      localStorage.setItem(
        "companyAvailability",
        action.payload.companyAvailability
      );
      return Object.assign({}, state, {
        authenticated: true,
        authenticating: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        isFirstLogin: action.payload.isFirstLogin,
      });
    case AUTH_AUTHORITY_CHANGED:
      if (!action.payload.authenticated) {
        localStorage.removeItem("access-token");
        localStorage.removeItem("refresh-token");
        permissions = {};
        currentPermissions = [];
      } else {
        permissions = state.permissions;
        currentPermissions = state.currentPermissions;
      }
      return Object.assign({}, state, {
        authenticated: action.payload.authenticated,
        permissions,
        currentPermissions,
      });
    case AUTH_AUTHENTICATING:
      return Object.assign({}, state, {
        authenticating: action.payload.authenticating,
      });
    case AUTH_INDEX_PERMISSIONS_SUCCESS:
      permissions = action.payload.permissions;
      if (permissions.user && action.payload.menu) {
        permissions.user = [...permissions.user, ...action.payload.menu];
      }
      currentPermissions = _newPermissions(permissions, state.currentRole);

      return Object.assign({}, state, {
        permissions,
        currentPermissions,
      });
    case AUTH_CURRENT_USER_SUCCESS:
      currentPosition =
        action.payload.user &&
        action.payload.user.positions &&
        action.payload.user.positions[0]
          ? action.payload.user.positions[0]
          : {};
      currentRole = action.payload.user && action.payload.user.activeRole; // &&
      // action.payload.user.roles[0])
      currentPermissions = _newPermissions(state.permissions, currentRole);
      return Object.assign({}, state, {
        currentUser: action.payload.user,
        currentPosition,
        currentPermissions,
        currentRole,
      });
    case AUTH_CURRENT_POSITION_SUCCESS:
      currentPosition = action.payload ? action.payload : {};
      // currentPermissions = _newPermissions(state.permissions, currentPosition);
      return Object.assign({}, state, {
        currentPosition,
        // currentPermissions,
      });
    case AUTH_CURRENT_ROLE_SUCCESS:
      currentRole = action.payload ? action.payload : {};
      currentPermissions = _newPermissions(state.permissions, currentRole);
      return Object.assign({}, state, {
        currentRole,
        currentPermissions,
      });
    case UI_PERMISSION_SUCCESS:
      let perm = {};
      try {
        perm = action.payload;
      } catch (e) {
        perm = {};
      }
      return Object.assign({}, state, {
        uiPermissions: perm ? perm : [],
      });
    case FETCH_COMPANY_LOGO_SUCCESS:
      return Object.assign({}, state, {
        companyLogo: action.payload.data,
      });
    case SMS_PERMISSION_SUCCESS:
      return Object.assign({}, state, {
        hasSmsPermission: action.payload,
      });
    default:
      return state;
  }
}
